<template>
  <transition name="fade">
    <div
      v-if="show"
      class="em"
    >
      <div
        ref="modal-container"
        class="em__container"
        @click="removeModal"
      >
        <div class="em__container__modal">
          <div class="header">
            <div
              v-for="(item, idx) in items"
              :key="item.number"
              :class="['header__item', {selected: (idx === selectedIdx)}]"
              @click="activateItem(idx)"
            >
              <div class="header__item__text">
                {{ item.title }}
              </div>
              <div class="header__item__underline" />
            </div>
          </div>
          <div class="body">
            <div class="body__title">
              {{ selectedItem.title }}
            </div>
            <div
              class="body__content"
              v-html="selectedItem.content"
            />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {type: Boolean, required: true},
    items: {type: Array, required: true},
  },
  data() {
    return {
      selectedIdx: 0,
    };
  },
  computed: {
    selectedItem() {
      return this.items[this.selectedIdx] || {};
    },
  },
  methods: {
    removeModal(e) {
      if (e.target == this.$refs['modal-container']) {
        this.$emit('close-modal');
      }
    },
    activateItem(idx) {
      this.selectedIdx = idx;
    },
  },
};
</script>

<style lang="scss" scoped>
.em {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;

  &__container {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255,255,255,0.65);

    &__modal {
      overflow-y: scroll;
      width: rem-calc(640);
      border-radius: 7px;
      background-color: white;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.22);

      .header {
        background-color: #273142;
        height: rem-calc(64);
        width: 100%;
        overflow-x: scroll;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-flow: row nowrap;

        &__item {
          // width: rem-calc(113);
          padding: 0 rem-calc(12);
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          cursor: pointer;

          &__text {
            font-family: 'OpenSans';
            font-weight: 600;
            color: rgba(175, 175, 175, 1);
          }

          &__underline {
            position: absolute;
            bottom: 0;
            height: 4px;
            left: 0;
            right: 0;
            background-color: rgba(175, 175, 175, 0);
          }

          &:hover {
            .header__item__underline {
              background-color: rgba(175, 175, 175, 1)
            }
          }

          &.selected {
            .header__item__text {
              color: rgba(255, 255, 255, 1);
            }
            .header__item__underline {
              background-color: rgba(255, 255, 255, 1);
            }
          }
        }
      }
      .body {
        height: rem-calc(212);
        background-color: white;
        overflow-y: scroll;
        padding: rem-calc(20);
        &__title {
          font-size: rem-calc(20);
          font-weight: 600;
          color: #1e4a5a;
          margin-bottom: rem-calc(20);
        }
        &__content {
          font-size: rem-calc(16);
          color: #1e4a5a;
        }
      }
    }
  }
}
</style>
